function PartsStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#F3E8FF] font-OpenSansSemiBold font-[600] text-[#7E22CE] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Parts
    </div>
  );
}

export default PartsStatus;
